export default {"src":"/_next/static/media/Public-Mint.1b5b0ff3.svg","height":92,"width":91};